export default from './delete-comment-modal';



// WEBPACK FOOTER //
// ./app/containers/delete-comment-modal/index.js